"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.clyde.description': 'Uomo britannico con potenza, sfumature e umorismo.',
};
